// extracted by mini-css-extract-plugin
module.exports = {"company-people-container":"company-people__company-people-container___2WoQd","list-container":"company-people__list-container___3gtc-"};